import { render } from "./IndexHeader.vue?vue&type=template&id=36f6ad10&scoped=true"
import script from "./IndexHeader.vue?vue&type=script&lang=js"
export * from "./IndexHeader.vue?vue&type=script&lang=js"

import "./IndexHeader.vue?vue&type=style&index=0&id=36f6ad10&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36f6ad10"]])

export default __exports__